export default function CpBadge({ min, max, total }) {
  if (total !== undefined) {
    return (
      <span className="inline-block px-2 py-0.5 rounded-full text-xs font-semibold text-amber bg-amber/10">
        {total} CP
      </span>
    );
  }
  return (
    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-semibold text-amber bg-amber/10">
      {min}-{max} CP
    </span>
  );
}
